import { can, CAPABILITY } from "./permissions";

export const MATERIAL_SEARCH_COLUMNS = [
  "material_id",
  "sku",
  "material_name",
  "description",
  "unit_of_measure",
  "active",
];

export const MATERIAL_PRICING_COLUMNS = [
  "unit_cost",
  "current_inventory",
  "sell_price",
];

export const MATERIAL_ADMIN_COLUMNS = [...MATERIAL_SEARCH_COLUMNS, ...MATERIAL_PRICING_COLUMNS];

/**
 * Supabase relation for catalog reads.
 * Employees use the RLS-safe view; manager+ use the base table (pricing columns).
 */
export function getMaterialRelationName(actor, orgPolicies) {
  if (can(actor, CAPABILITY.MATERIAL_CATALOG_EDIT, {}, orgPolicies)) {
    return "materials";
  }

  if (can(actor, CAPABILITY.MATERIAL_CATALOG_VIEW_PRICING, {}, orgPolicies)) {
    return "materials";
  }

  return "materials_search";
}

/**
 * Supabase select string for material catalog queries based on actor permissions.
 */
export function getMaterialSelectColumns(actor, orgPolicies) {
  if (can(actor, CAPABILITY.MATERIAL_CATALOG_EDIT, {}, orgPolicies)) {
    return MATERIAL_ADMIN_COLUMNS.join(", ");
  }

  if (can(actor, CAPABILITY.MATERIAL_CATALOG_VIEW_PRICING, {}, orgPolicies)) {
    return MATERIAL_ADMIN_COLUMNS.join(", ");
  }

  return MATERIAL_SEARCH_COLUMNS.join(", ");
}

/**
 * Strip pricing and valuation fields from a material row for employee-safe display.
 */
export function stripMaterialPricingFields(material = {}) {
  if (!material || typeof material !== "object") {
    return material;
  }

  const {
    unit_cost: _unitCost,
    current_inventory: _inventory,
    sell_price: _sellPrice,
    ...safe
  } = material;

  return safe;
}

export function stripMaterialPricingFromList(materials = []) {
  return (materials || []).map(stripMaterialPricingFields);
}
